// removed by extract-text-webpack-plugin
module.exports = {"absolute-center":"onfido-sdk-ui-Uploader-absolute-center","container":"onfido-sdk-ui-Uploader-container","instructions":"onfido-sdk-ui-Uploader-instructions","instructionsCopy":"onfido-sdk-ui-Uploader-instructionsCopy","error":"onfido-sdk-ui-Uploader-error","icon":"onfido-sdk-ui-Uploader-icon","identityIcon":"onfido-sdk-ui-Uploader-identityIcon","buttons":"onfido-sdk-ui-Uploader-buttons","button":"onfido-sdk-ui-Uploader-button","proofOfAddressIcon":"onfido-sdk-ui-Uploader-proofOfAddressIcon","uploaderWrapper":"onfido-sdk-ui-Uploader-uploaderWrapper","uploadArea":"onfido-sdk-ui-Uploader-uploadArea"};


//////////////////
// WEBPACK FOOTER
// ./components/Uploader/style.css
// module id = 387
// module chunks = 1